import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { FaFilter } from 'react-icons/fa'
import CustomSelect from './CustomSelect'
import moment from 'moment'
import { usePDLContextData } from '../Context'
import {
  getCityDepotContract,
  getLastRefreshDate
} from '../../../../../services/cesl-bus/pdlService'
import { getISTDate } from '../../../../Shared/common'

const initial = {
  search: [],
  city: [],
  depot: [],
  contract: []
}

const makeOptions = (data, key) =>
  [...new Set(data.map(x => x[key]).filter(Boolean))].map(x => ({
    label: x,
    value: x
  }))

export default function CustomFilter({ onApply, onReset }) {
  const { GlobalFilter, setGlobalFilters } = usePDLContextData()
  const [filters, setFilters] = useState(initial)
  const [showFilter, setShowFilter] = useState(false)
  const [data, setData] = useState([])
  const [options, setOptions] = useState({ city: [], depot: [], contract: [] })
  const [lastRefreshDate, setLastRefreshDate] = useState('--')

  useEffect(() => {
    getCityDepotContract()
      .then(res => setData(res?.data || []))
      .catch(err => setData([]))

    getLastRefreshDate()
      .then(res => {
        setLastRefreshDate(res?.lastRefreshDate || '--')
        setFilters(prev => ({
          ...prev,
          startDate: moment(res?.lastRefreshDate, 'YYYY-MM-DD').toDate(),
          endDate: moment(res?.lastRefreshDate, 'YYYY-MM-DD').toDate()
        }))
      })
      .catch(err => setLastRefreshDate('--'))
  }, [])


  useEffect(() => {
    setOptions({
      city: makeOptions(data, 'city'),
      depot: makeOptions(data, 'depot'),
      contract: makeOptions(data, 'contract')
    })
    setFilters({
      ...initial,
      city: makeOptions(data, 'city'),
      depot: makeOptions(data, 'depot'),
      contract: makeOptions(data, 'contract')
    })
  }, [data])


  const related = (selected, key) => {
    const values = selected.map(x => x.value)

    if (!values.length) {
      return {
        city: [],
        depot: [],
        contract: []
      }
    }

    const rows = data.filter(x => values.includes(x[key]))

    return {
      city: makeOptions(rows, 'city'),
      depot: makeOptions(rows, 'depot'),
      contract: makeOptions(rows, 'contract')
    }
  }

  const updateFilter = (selected, name) => {
    const selectedItems = selected || []
    const r = related(selectedItems, name)

    setOptions(prev => ({
      ...prev,
      city: name === 'city' ? prev.city : r.city,
      depot: name === 'depot' ? prev.depot : r.depot,
      contract: name === 'contract' ? prev.contract : r.contract
    }))

    setFilters(prev => ({
      ...prev,
      [name]: selectedItems,
      city: name === 'city' ? selectedItems : r.city,
      depot: name === 'depot' ? selectedItems : r.depot,
      contract: name === 'contract' ? selectedItems : r.contract
    }))
  }

  const update = (key, value) => setFilters(p => ({ ...p, [key]: value }))

  const submit = e => {
    e.preventDefault()

    const updatedFilters = {
      ...filters,
      startDate: getISTDate(filters.startDate),
      endDate: getISTDate(filters.endDate)
    }

    setGlobalFilters(prev => ({
      ...prev,
      ...updatedFilters
    }))

    onApply?.(updatedFilters)
  }

  const reset = e => {
    e.preventDefault()

    const allOptions = {
      city: makeOptions(data, 'city'),
      depot: makeOptions(data, 'depot'),
      contract: makeOptions(data, 'contract')
    }

    const f = {
      ...initial,
      ...allOptions,
      startDate: moment(lastRefreshDate, 'YYYY-MM-DD').toDate(),
      endDate: moment(lastRefreshDate, 'YYYY-MM-DD').toDate(),
    }

    setOptions(allOptions)
    setFilters(f)

    const resetFilters = {
      ...f,
      startDate: getISTDate(f.startDate),
      endDate: getISTDate(f.endDate)
    }

    setGlobalFilters(prev => ({
      ...prev,
      ...resetFilters
    }))

    onReset?.(resetFilters)
  }

  return (
    <>
      <div className='container-fluid pt-1 cardBox'>
        <div className='card'>
          <div className='card-body busflt'>
            <div className='row d-flex justify-content-between'>
              <div className='col-lg-4 col-sm-4 d-flex justify-content-start align-items-center'>
                <p className='my-auto small'>
                  Last Refresh Date: {lastRefreshDate}
                </p>
              </div>

              <div className='col-lg-4 col-sm-4  d-none d-md-flex justify-content-center align-items-center'>
                <h5 className='mb-0 font-bus-head'>PDL</h5>
              </div>

              <div className='col-lg-4 col-sm-4 text-end filter_bus_icon_f'>
                <button
                  type='button'
                  onClick={() => setShowFilter(p => !p)}
                  className='btn btn-sm btn-outline-primary material-icons filter_bus_icon'
                >
                  <FaFilter />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='container-fluid'>
        <div
          className='FilterDiv_bus p-2 mb-3'
          style={{ display: showFilter ? 'block' : 'none', zIndex: 1 }}
        >
          <form className='g-3 mt-2 filterForm' onSubmit={submit}>
            <div className='row'>
              <div className='col-lg-2 col-md-6 col-sm-12'>
                <label className='form-label_bus'>Search</label>
                <input
                  value={filters.search}
                  onChange={e =>
                    update(
                      'search',
                      e.target.value ? e.target.value.split(',') : []
                    )
                  }
                  className='top-filter filter-col form-control'
                  placeholder='Search...'
                  autoComplete='off'
                />
              </div>

              <div className='col-lg-2 col-md-6 col-sm-12' style={{ zIndex: 2 }}>
                <label className='form-label_bus'>Date Range</label>
                <DatePicker
                  selectsRange
                  startDate={filters.startDate}
                  endDate={filters.endDate}
                  onChange={([start, end]) => {
                    update('startDate', start)
                    update('endDate', end)
                  }}
                  maxDate={new Date()}
                  dateFormat='dd-MM-yyyy'
                  placeholderText='Select Start Date - End Date'
                  className='form-control'
                  isClearable
                  wrapperClassName='w-100'
                />
              </div>

              <div className='col-lg-2 col-md-6 col-sm-12'>
                <CustomSelect
                  name='city'
                  options={options.city}
                  value={filters.city}
                  isMulti
                  placeholder='Select City'
                  onChange={updateFilter}
                />
              </div>

              <div className='col-lg-2 col-md-6 col-sm-12'>
                <CustomSelect
                  name='depot'
                  options={options.depot}
                  value={filters.depot}
                  isMulti
                  placeholder='Select Depot'
                  onChange={updateFilter}
                />
              </div>

              <div className='col-lg-2 col-md-6 col-sm-12 mb-1'>
                <CustomSelect
                  name='contract'
                  options={options.contract}
                  value={filters.contract}
                  isMulti
                  placeholder='Select Contract'
                  onChange={updateFilter}
                />
              </div>

              <div className='col-lg-1 col-md-6 col-sm-12 d-flex align-items-center mt-1'>
                <button className='fleet-btn fleet-btn-sm blue-theme h-50 custom-Btn-animation mr-1'>
                  Apply
                </button>

                <button
                  type='button'
                  onClick={reset}
                  className='fleet-btn fleet-btn-sm gray-theme  h-50 custom-Btn-animation'
                >
                  Reset
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}